/**
 * Component is used to compare elements of array(that comes from redux store) and conditionally show the content
 * in case array contains needed value
 *
 * @attr {string} name - Define the path to selected array in the store
 * @attr {string} contain-value - Define the value that array in store should contain
 * @attr {boolean} not - Invert the component behaviour so the content is hidden in case the 'name' contains 'contain-value'
 * @attr {boolean} contain-object - If defined then the 'contain-value' should be a property of the object that array contains
 * @attr {string} property-name - The property of the object that should be checked if 'contain-object' is defined
 * @attr {string} separator - It allows multiple values to be provided with 'contain-value'
 *
 * HTML Structure Example
 *
 * <e2-when-contain name="wishlist.fullyAdded" contain-value="acc">
 *     <!-- CONTENT HERE -->
 * </e2-when-contain>
 */

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { getValueByStorePath } from '@elab/core/utils/helpers';

export class WhenContain extends SimpleLitElement {
    static get properties() {
        return {
            refName: { type: String, attribute: 'name' },
            containValue: { type: String, attribute: 'contain-value' },
            not: { type: Boolean },
            hidden: { type: Boolean, reflect: true },
            loaded: { type: Boolean, reflect: true },
            containObject: { type: Boolean, attribute: 'contain-object' },
            propertyName: { type: String, attribute: 'property-name' },
            separator: { type: String, attribute: 'separator' },
        };
    }

    constructor() {
        super();

        this.refName = '';
        this.containObject = false;
        this.propertyName = '';
        this.separator = '';
        this.hidden = true;
        this.loaded = false;
    }
}

const mapStateToProps = (state, ctx) => {
    const { containValue, not, refName, containObject, propertyName, separator } = ctx;
    const fieldArr = getValueByStorePath(refName, state);

    const check = val => {
        if (separator) {
            const values = containValue.split(separator);
            return values.find(value => value === val);
        }

        return containValue === val;
    };

    const isEqual =
        fieldArr && fieldArr.length
            ? fieldArr.find(val =>
                  containObject ? check(val[propertyName].toString()) : check(val.toString()),
              )
            : false;
    return {
        hidden: not ? isEqual : !isEqual,
    };
};

export default () =>
    customElements.define('e2-when-contain', connect(mapStateToProps)(WhenContain));
